module.exports = __webpack_public_path__ + "static/media/1005330.21ae3b46.png";